import { auth, db } from "../firebase";
import firebase from "firebase/compat/app";

function safeLower(value) {
  return typeof value === "string" ? value.trim().toLowerCase() : null;
}

function safeString(value) {
  return typeof value === "string" ? value.trim() : "";
}

export async function syncAuthUserToFirestore(userArg) {
  const candidate = userArg || auth.currentUser;
  if (!candidate?.uid) return null;

  // Refresh auth profile first, especially important after custom-token sign in
  try {
    await candidate.reload();
  } catch (err) {
    console.warn("[syncAuthUserToFirestore] reload skipped/failed:", err?.message);
  }

  const user = auth.currentUser || candidate;
  if (!user?.uid) return null;

  // Ensure token is available for Firestore rules
  try {
    await user.getIdToken(true);
  } catch (err) {
    console.warn("[syncAuthUserToFirestore] token refresh failed:", err?.message);
  }

  const email = safeString(user.email) || null;
  const emailLower = email ? safeLower(email) : null;
  const displayName = safeString(user.displayName);
  const phone = safeString(user.phoneNumber) || null;

  const userRef = db.collection("users").doc(user.uid);
  const snap = await userRef.get();
  const existing = snap.exists ? snap.data() || {} : {};

  const payload = {
    uid: user.uid,

    // Auth-backed identity fields
    email,
    emailLower,
    phone,
    displayName,

    // Preserve existing access model if already assigned
    roles: Array.isArray(existing.roles) ? existing.roles : [],
    permissions:
      existing.permissions && typeof existing.permissions === "object"
        ? {
            sellerPrepApproval: !!existing.permissions.sellerPrepApproval,
            tradeIssueManagement: !!existing.permissions.tradeIssueManagement,
            inspectionReview: !!existing.permissions.inspectionReview,
            pickupManagement: !!existing.permissions.pickupManagement,
            deliveryManagement: !!existing.permissions.deliveryManagement,
            roleManagement: !!existing.permissions.roleManagement,
          }
        : {
            sellerPrepApproval: false,
            tradeIssueManagement: false,
            inspectionReview: false,
            pickupManagement: false,
            deliveryManagement: false,
            roleManagement: false,
          },

    staffProfile:
      existing.staffProfile && typeof existing.staffProfile === "object"
        ? {
            inspectorType: existing.staffProfile.inspectorType || null,
            partnerId: existing.staffProfile.partnerId || null,
            storeId: existing.staffProfile.storeId || null,
          }
        : {
            inspectorType: null,
            partnerId: null,
            storeId: null,
          },

    // Do not accidentally deactivate existing users
    isActive: existing.isActive !== false,

    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  };

  if (!snap.exists) {
    payload.createdAt = firebase.firestore.FieldValue.serverTimestamp();
  }

  await userRef.set(payload, { merge: true });
  return payload;
}